export default __webpack_public_path__ + "static/hero-bg1-01011ac7e4283a3d75cb0d690b946b13.jpg";